module.exports = __webpack_public_path__ + "img/audio_thumbnail_magne.f5211444.png";